import React from 'react'
import { Button, Modal, Form, Row, Col } from 'react-bootstrap'
import { Trans } from 'react-i18next'
import i18next from 'i18next'
import DayPicker from '../system_wide/day_picker'
import { isValid, parseISO } from 'date-fns'

const { t } = i18next
class ChangeStatusModal extends React.Component {
  static defaultProps = {
    pending: false,
    onSave: () => {},
    onExited: () => {},
  }

  state = {
    show: false,
    id: null,
    code: '',
    status: 'pending',
    rejected_note: '',
    date: null,
    minDate: null,
  }

  show = appointment => {
    let { id, code, status = 'pending', rejected_note = '', date = null, minDate = new Date() } = appointment
    const parsedDate = date instanceof Date ? date : typeof date === 'string' ? parseISO(date) : minDate

    this.setState({
      show: true,
      id,
      code,
      status,
      rejected_note,
      date: parsedDate,
      minDate,
    })
  }

  hide = () => {
    this.setState({ show: false, status: 'pending', rejected_note: '' })
  }

  handleStatusChange = ({ target: { value } }) => {
    this.setState({ status: value, rejected_note: '' }) // Reset note quando cambia lo stato
  }

  handleNoteChange = ({ target: { value } }) => {
    this.setState({ rejected_note: value })
  }
  handleChangeDate = name => target => {
    this.setState({ [name]: target.value })
  }

  handleConfirm = async () => {
    const { id, code, status, rejected_note, date } = this.state
    await this.props.onSave({ id, code, status, rejected_note, date })
    this.hide()
  }
  isFormValid = () => {
    const { status, date, minDate } = this.state
    if (status !== 'pending') {
      return date && isValid(date) && date >= minDate && date <= new Date()
    }

    return status
  }

  render() {
    const { show, code, status, rejected_note, date, minDate } = this.state
    return (
      <Modal backdrop="static" centered show={show} onHide={this.hide} onExited={this.props.onExited} size="xs">
        <Modal.Header>
          <Modal.Title>
            <Trans i18nKey="components.appointments.change_status_modal.title">Cambia stato visita</Trans>: {code}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Form.Group as={Col} md={6} sm={12}>
                <Form.Label>
                  <Trans i18nKey="components.appointments.change_status_modal.select_status">Seleziona stato</Trans>
                </Form.Label>
                <div>
                  <Form.Check
                    type="radio"
                    id="pending"
                    label={t('components.appointments.change_status_modal.pending', 'Inserita')}
                    value="pending"
                    checked={status === 'pending'}
                    onChange={this.handleStatusChange}
                  />
                  <Form.Check
                    type="radio"
                    id="rejected"
                    label={t('components.appointments.change_status_modal.rejected', 'Rifiutata')}
                    value="rejected"
                    checked={status === 'rejected'}
                    onChange={this.handleStatusChange}
                  />
                  <Form.Check
                    type="radio"
                    id="concluded"
                    label={t('components.appointments.change_status_modal.concluded', 'Conclusa')}
                    value="concluded"
                    checked={status === 'concluded'}
                    onChange={this.handleStatusChange}
                  />
                </div>
              </Form.Group>
              {status !== 'pending' && (
                <Form.Group as={Col} md={6} sm={12}>
                  <Form.Label>
                    <Trans i18nKey="components.appointments.change_status_modal..date_change">Data cambio stato</Trans>
                    <span> *</span>
                  </Form.Label>
                  <div style={{ width: '15rem' }}>
                    <DayPicker
                      value={date}
                      onChange={this.handleChangeDate('date')}
                      minDate={minDate}
                      maxDate={new Date()}
                    />
                  </div>
                </Form.Group>
              )}
            </Row>

            {status === 'rejected' && (
              <Form.Group>
                <Form.Label>
                  <Trans i18nKey="components.appointments.change_status_modal.note_label">Motivo del rifiuto</Trans>
                </Form.Label>
                <Form.Control as="textarea" value={rejected_note} onChange={this.handleNoteChange} rows={3} />
              </Form.Group>
            )}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.hide} variant="secondary">
            <Trans i18nKey="buttons.cancel">Annulla</Trans>
          </Button>
          <Button onClick={this.handleConfirm} variant="primary" disabled={this.props.pending || !this.isFormValid()}>
            <Trans i18nKey="buttons.confirm">Conferma</Trans>
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

export default ChangeStatusModal
